import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import PropTypes from 'prop-types';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';

import Header from "../../components/Header/Header.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Parallax from "../../components/Parallax/Parallax.jsx";

import SectionCatalog from "./Sections/SectionCatalog";
import FooterSection from "../LandingPage/Sections/FooterSection";

import toursPageStyle from "../../assets/jss/material-kit-pro-react/views/toursStyle";

import { getTours } from '../../actions/toursActions';

import headerImg from "../../assets/img/landing-bg.jpg";
import Spinner from '../../components/common/Spinner';

class ToursPage extends React.Component {
    componentDidMount() {
        this.props.getTours();

        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    }

    render() {
        const { classes, toursReducer } = this.props;
        const { loading } = toursReducer;

        let productsSection;

        if (toursReducer.tours.length===0 || loading) {
            productsSection = <Spinner />;
        } else {
            productsSection = <SectionCatalog tours={toursReducer.tours} />;
        }

        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Tours | Vivamos el Campo - Turismo Rural</title>
                    <link rel="canonical" href="https://vivamoselcampo.co/tours" />
                    <meta name="description" content="Conoce los Tours y Paquetes que tenemos para ti. Experiencias que solo se viven en el ambiente rural" />
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="transparent"
                    links={<HeaderLinks dropdownHoverColor="info" />}
                    changeColorOnScroll={{
                        height: 180,
                        color: "white"
                    }}
                />
                <Parallax
                    image={headerImg}
                    filter="dark"
                    small
                >
                    <div className={classes.container}>
                        <GridContainer>
                            <GridItem md={8} sm={8} className={classNames(classes.mlAuto, classes.mrAuto, classes.textCenter)}>
                                <div className={classes.brand}>
                                    <h1 className={classes.title}>Tours - Paquetes Turísticos</h1>
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </Parallax>
                <div className={classNames(classes.main, classes.mainRaised)}>

                    {productsSection}

                    <FooterSection />
                </div>
            </div>
        );
    }
}

ToursPage.propTypes = {
    getTours: PropTypes.func.isRequired,
    toursReducer: PropTypes.object,
    filtersReducer: PropTypes.object
};

const mapStateToProps = state => ({
    toursReducer: state.toursReducer,
    filtersReducer: state.filtersReducer
});

export default connect(mapStateToProps, { getTours })( withStyles(toursPageStyle)(ToursPage) );


// WEBPACK FOOTER //
// ./src/views/ToursPage/ToursPage.jsx